export default __webpack_public_path__ + "static/media/1995.0a2bb0fe.png";